import React, { useState } from "react";

const AddCategory = () => {
  const [form, setForm] = useState({
    name: "",
    description: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("New Category:", form);
    // 🔹 API call to save category goes here
    // await axios.post(`${BASE_URL}/categories`, form, getAuthHeaders());
    setForm({ name: "", description: "" }); // reset form
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">📂 Add Category</h1>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-lg">
        <input
          type="text"
          name="name"
          placeholder="Category Name"
          value={form.name}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
          required
        />
        <textarea
          name="description"
          placeholder="Category Description"
          value={form.description}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          Save Category
        </button>
      </form>
    </div>
  );
};

export default AddCategory;
